// Shared style for the below-image action buttons (Replay / Preview) in the
// Original and Result panes — sits in normal flow under the media box instead
// of overlaid on top of it, so it's visible without hovering. Extracted out of
// ImageAnimatorModal.jsx so AnimationEditMode.jsx can import it without a
// circular module dependency.
export const belowImageBtnStyle = {
  display: "flex",
  alignItems: "center",
  gap: 4,
  padding: "4px 10px",
  borderRadius: 6,
  border: "1px solid #e2e8f0",
  background: "#fff",
  color: "#475569",
  fontSize: 11,
  fontWeight: 600,
  cursor: "pointer",
};
